import React, { Component } from 'react';

class Footer extends Component {
    constructor(props) {
        super(props);

        this.backLabel = "naar overzicht";
        this.previousLabel = "vorige";
        this.nextLabel = "volgende";

        if (props.backLabel) this.nextLabel = props.backLabel
        if (props.previousLabel) this.nextLabel = props.previousLabel
        if (props.nextLabel) this.nextLabel = props.nextLabel
    }

    GetLabelClassBack() {
        const labelClass=this.props.backLabelClass? this.props.backLabelClass : "btn-secondary";
        return `btn ${labelClass} `;
    }

    GetLabelClassPrevious() {
        const labelClass=this.props.previousLabelClass? this.props.previousLabelClass : "btn-primary";
        return `btn ${labelClass} float-end me-2`;
    }

    GetLabelClassNext() {
        const labelClass=this.props.nextLabelClass? this.props.nextLabelClass : "btn-primary";
        return `btn ${labelClass} float-end`;
    }

    render() {
        return <div className="footer footer-content">
            <button className={this.GetLabelClassBack()} onClick={this.props.back}><i className="fa-solid fa-arrow-left"></i> {this.backLabel}</button>

            {this.props.next &&
                <button className={this.GetLabelClassNext()} onClick={this.props.next}>{this.nextLabel}</button>
            } 

            {!this.props.next &&
                <button className="btn invisible float-end">volgende</button>
            } 
            
            {this.props.previous &&
                <button className={this.GetLabelClassPrevious()} onClick={this.props.previous}>{this.previousLabel}</button>
            }
        </div>
    }
}


export default Footer;